import FolderOverview from 'scoreboard/components/folder-overview'
import permissions from 'scoreboard/components/permissions'

var DashboardsFolderOverview = FolderOverview.extend({

	allowEdit: function() {
		return permissions.dashboards(this.model.get('organizationId')) && permissions.isEditableIfReplicated(this.model)
	}

})

export default DashboardsFolderOverview

DashboardsFolderOverview.__filename__ = 'dashboards/dashboards-folder-overview.js'
